import React from 'react';
import { ListItemButton, SvgIconProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link, useRouteMatch } from 'react-router-dom';


const useStyles = makeStyles()(theme => ({
  root: {
    height: '56px',
    paddingLeft: theme.spacing(3),
  },
  rootActive: {
    color: theme.palette.secondary.main
  },
  icon: {
    fontSize: '28px',
    color: 'inherit',
  },
  title: {
    paddingLeft: theme.spacing(3),
    fontWeight: 400,
  }
}));


export type MobileNavigationLinkProps = {
  title: string;
  icon: React.ComponentType<SvgIconProps>;
  iconActive?: React.ComponentType<SvgIconProps>;
  path?: string;
  onClick?: () => void;
  exact?: boolean;
  asAnchor?: boolean;
};


export const MobileNavigationLink: React.FC<MobileNavigationLinkProps> = (props) => {
  const { classes, cx } = useStyles();
  const match = useRouteMatch({
    path: props.path,
    exact: props.exact,
  });

  const rootClassName = cx(classes.root, {
    [classes.rootActive]: !!match,
  });

  const CurrentIcon = match ? (props.iconActive || props.icon) : props.icon;

  const rootProps = React.useMemo(() => {
    if (props.asAnchor) {
      return {
        component: 'a',
        href: props.path,
        target: '_blank',
        rel: 'noopener noreferrer'
      };
    }

    if (props.path) {
      return {
        component: Link,
        to: props.path,
      };
    }

    return {
      onClick: props.onClick,
    };
  }, [ props.asAnchor, props.onClick, props.path ]);

  return (
    <ListItemButton {...rootProps} className={rootClassName}>
      <CurrentIcon className={classes.icon} />
      <Typography variant="h5" className={classes.title}>{props.title}</Typography>
    </ListItemButton>
  );
};
